import getInstanceAxios from './RequestGlobalConfig'

export const author = getInstanceAxios(process.env.REACT_APP_BASE_API_AUTHOR)
export const authorV2 = getInstanceAxios(process.env.REACT_APP_BASE_AUTHENTICATOR_V2_API_URL)
export const listMenu = getInstanceAxios(process.env.REACT_APP_GET_LIST_MENU)
